import { useRouter } from 'next/router'
import { useSession } from 'next-auth/react'
import { MouseEvent, useContext } from 'react'
import { match } from 'ts-pattern'
import { AuthModalContext } from './Auth/AuthModalContext'
import { HeartIcon } from './EventCard.style'
import { UserActionsContext } from './User/UserActionsContext'

interface EventHeartProps {
  toggleFavorite: (event: MouseEvent<SVGElement>) => void
  isUserEventFavoriteSelected: boolean | undefined
  eventId: number
}

export const EventHeart = ({
  toggleFavorite,
  isUserEventFavoriteSelected,
  eventId
}: EventHeartProps) => {
  const session = useSession()
  const { setEventId } = useContext(UserActionsContext)
  const { setModalParams } = useContext(AuthModalContext)
  const router = useRouter()

  const displaySignInModal = (event: MouseEvent<SVGElement>) => {
    event.preventDefault()
    setEventId(eventId)
    setModalParams({
      redirectUrl: router.asPath,
      state: 'SIGNIN'
    })
  }

  return match(session)
    .with({ status: 'loading' }, () => null)
    .with({ status: 'authenticated' }, () => (
      <HeartIcon
        $absolute
        onClick={toggleFavorite}
        $selected={isUserEventFavoriteSelected}
      />
    ))
    .with({ status: 'unauthenticated' }, () => (
      <HeartIcon onClick={displaySignInModal} $selected={false} $absolute />
    ))
    .exhaustive()
}
